module.exports = __webpack_public_path__ + "media/images/icons/call-453a8620882473505107b60d22595a37.png";